import React from 'react';
import { Stack, Text } from 'library/ui';

export default function WorkerReviewCopy() {
    return (
        <Stack gap="sm">
            <Text>Reviews help Tandem provide you the highest quality and most reliable staff possible!</Text>
            <Text>
                When you leave a positive review, workers are rewarded and given points! If you have a poor experience,
                you&apos;ll have a chance to tell us you don&apos;t want them back (and don&apos;t worry, we won&apos;t
                show them the review!)
            </Text>
        </Stack>
    );
}
